exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".salesforce-warning {\n  display: flex; }\n  .salesforce-warning .salesforce-warning-message {\n    width: auto; }\n\n.crm-saml-sso-settings {\n  margin-left: 4rem;\n  margin-bottom: 2rem; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?sourceMap!./src/components/pages/pages/GlobalBarConfiguration.scss
// module id = 1371
// module chunks = 0